import { useCompanySaleCheck } from "context/useCompanySaleCheck";
import { useConfigPermission } from "context/useConfigPermission";
import { useOrders } from "context/useOrderData";
import { useProductConfiguration } from "context/useProductConfiguration";
import { WebshopId } from "models/WebShop";
import { Link, useParams } from "react-router-dom";
import { UrlPath } from "utility/routes";

const LogoPromo = () => {
  const params = useParams();
  const companyId = params.id ?? "";
  const { companySaleCheck } = useCompanySaleCheck();
  const { saleStatusByCompany } = useOrders();
  const { productConfigurationsByCompany } = useProductConfiguration();
  const { canConfig } = useConfigPermission();

  const path = `${UrlPath.Account.WebShopBase}/${companyId}/${UrlPath.Account.ProductConfig.Logo}`;


  if (companyId === "" || companySaleCheck[companyId] === undefined || !companySaleCheck[companyId]?.allowed)
    return null;

  const showSalePromo = companySaleCheck[companyId]?.allowed && !saleStatusByCompany[companyId]?.orderStatuses.some(x => x.activeProducts.some(p => p.id === WebshopId.logo)) && productConfigurationsByCompany[companyId]?.logo === null;
  const showConfig = productConfigurationsByCompany[companyId].logo !== undefined && productConfigurationsByCompany[companyId].logo !== null && canConfig(companyId);

  return showSalePromo ? (
    <div className="card mt-4">
      <div className="card-header">
        <h2 className="fs-5">Logo</h2>
      </div>
      <div className="card-body">
        <Link to={path}><img src="/min-bedrift-ill-logo.svg" width="800" height="520" alt="" className="cc-card-shop-promo-ill" style={{ marginTop: 0 }} /></Link>
        <p>Vis din bedrifts logo i 1881s tjenester på nett og app.</p>
        <p className="mb-0"><Link to={path} className="btn btn-primary text-white">Kjøp visning av logo</Link></p>
      </div>
    </div>
  ) :
    (showConfig ? 
    <div className="card mt-4">
      <div className="card-header">
        <h2 className="fs-5">Logo</h2>
      </div>
      <div className="card-body">
        <p><img src={productConfigurationsByCompany[companyId].logo?.publicUrlTransform} alt="Logo" style={{ width: "140px", height: "60px", objectFit: "contain" }}></img></p>
        <div className="mb-0 d-md-flex justify-content-between align-items-center">
                        <div>
                            <Link
                                to={`${UrlPath.Account.Company}/${params.id}/${UrlPath.Account.Actions.Products}/${UrlPath.Account.ProductConfig.Logo}`}
                                className="btn btn-primary text-white">Endre logo</Link>
                        </div>
                        <div className="mt-3 mt-md-0">
                            <Link
                                to={`${UrlPath.Account.Company}/${params.id}/${UrlPath.Account.Actions.Products}/${UrlPath.Account.ProductConfig.Logo}`}
                                className="cc-icon-text-link text-muted"><i className="bi bi-box"></i> <span>Kjøpt produkt</span></Link>
                        </div>
                    </div>
      </div>
    </div> 
    : null)

};

export default LogoPromo;